<form class="fix-editor">
    <mat-form-field class="ag-row fix-mat-form">
        <input
            matInput
            [formControl]="letterFormControl()"
            [sanitizeChars]="notAdmissibleCharsRegexp()"
            [focusSelectOn]="cellReady()"
        />
    </mat-form-field>
</form>
